interface SidebarFilterProps {
  items: string[];
  selected: string;
  onSelect: (item: string) => void;
  children: React.ReactNode;
  stickyTopClass?: string;
}

export function SidebarFilter({ items, selected, onSelect, children, stickyTopClass = "top-16" }: SidebarFilterProps) {
  return (
    <div className="flex flex-col md:flex-row">
      {/* Desktop left sidebar — sticky */}
      <aside className={`hidden md:block w-44 shrink-0 border-r border-slate-200 bg-white self-start sticky ${stickyTopClass} max-h-[calc(100vh-4rem)] overflow-y-auto`}>
        {items.map((item) => {
          const isActive = item === selected;
          return (
            <button
              key={item}
              onClick={() => onSelect(item)}
              aria-pressed={isActive}
              className={`w-full text-left px-4 py-3 text-sm border-l-[3px] transition-colors ${
                isActive
                  ? "border-[#1e3a5f] bg-slate-50 font-bold text-[#1e3a5f]"
                  : "border-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-800 font-medium"
              }`}
            >
              {item}
            </button>
          );
        })}
      </aside>

      {/* Mobile horizontal pill strip */}
      <div className="md:hidden border-b border-slate-200 bg-white">
        <div className="flex gap-2 overflow-x-auto px-4 py-2.5" style={{ scrollbarWidth: "none" }}>
          {items.map((item) => {
            const isActive = item === selected;
            return (
              <button
                key={item}
                onClick={() => onSelect(item)}
                className={`flex-shrink-0 px-3.5 py-1.5 rounded-full text-sm font-semibold border transition-all ${
                  isActive
                    ? "bg-[#1e3a5f] text-white border-[#1e3a5f]"
                    : "bg-white text-slate-500 border-slate-200"
                }`}
              >
                {item}
              </button>
            );
          })}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        {children}
      </div>
    </div>
  );
}
